import { render } from "./OrderAll.vue?vue&type=template&id=135f3f98&scoped=true"
import script from "./OrderAll.vue?vue&type=script&lang=js"
export * from "./OrderAll.vue?vue&type=script&lang=js"

import "./OrderAll.vue?vue&type=style&index=0&id=135f3f98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-135f3f98"

export default script